module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('v-ons-splitter', [_c('v-ons-splitter-side', {
    staticClass: "l-menu",
    attrs: {
      "swipeable": "",
      "side": "left",
      "collapse": "",
      "width": "260px",
      "swipe-target-width": _vm.md && 25,
      "animation": _vm.md ? 'overlay' : 'reveal',
      "open": _vm.isOpen
    },
    on: {
      "update:open": function($event) {
        _vm.isOpen = $event
      }
    }
  }, [_c('menu-page')], 1), _vm._v(" "), _c('v-ons-splitter-content', [_c('app-tabbar')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f25e8402","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppSplitter.vue
// module id = 243
// module chunks = 0